import { recordKeys } from '../../../utility-functions';

/**
 * All the available LCIDs that fortress uses
 */
export type LCID = 1033 | 1036 | 1037 | 2057 | 3084 | 4105 | 1032 | 6153;

/**
 * Record for the link between LCID and culture code
 */
export const locales: Record<LCID, string> = {
  1033: 'en-US',
  1036: 'fr-FR',
  1037: 'he-IL',
  2057: 'en-GB',
  3084: 'fr-CA',
  4105: 'en-CA',
  1032: 'el-GR',
  6153: 'en-IE'
};

/**
 * Get the lcid that is assigned to a culture code,
 * Or undefined if not found
 */
export function getLcidByCultureCode(cultureCode: string): LCID | undefined {
  return recordKeys(locales).find((locale) => locales[locale] === cultureCode);
}
